import React from "react";
import { ToolbarOptions } from "../../interfaces/config";
import ToolbarButton from "./ToolbarButton";
import { useStore } from "../../stores/store.ts";
import { togglePropertyInfo } from "./propertyInfo";

import { executeToolbarActions } from "./toolbarActions.ts";

// Custom Components
// import BasemapsDropdown from "./BasemapsDropdown/BasemapsDropdown";

//Icons
// @ts-ignore
import navigationIcon from "./icons/navigation.png";
// @ts-ignore
import measureIcon from "./icons/measure.png";
// @ts-ignore
import propertyInfoIcon from "./icons/info.png";
// @ts-ignore
import bufferIcon from "./icons/buffer.png";
// @ts-ignore
import triViewIcon from "./icons/triView.png";
// @ts-ignore
import markupIcon from "./icons/markupTools.png";
// @ts-ignore
import clearMapIcon from "./icons/clearMap.png";
// @ts-ignore
import printIcon from "./icons/print.png";
// @ts-ignore
import basemapIcon from "./icons/basemap.png";
// @ts-ignore
import xYIcon from "./icons/xy.png";
// @ts-ignore
import layersIcon from "./icons/layers.png";
// @ts-ignore
import resultsIcon from "./icons/results.png";

import NavigationDropdown from "./NavigationDropdown/NavigationDropdown.tsx";
import { DraggableKeys } from "../../interfaces/config";

type ToolbarButton = {
  label: string;
  value: string;
  group: string;
  icon?: string;
  component?: React.FC;
  noToggle?: boolean;
  noMobile?: boolean;
  hideLabelOnMobile?: boolean;
  hideLabelOnTablet?: boolean;
  hidden?: boolean;
};

export const Toolbar = (props: { options: ToolbarOptions }) => {
  const { toggleActiveItem, isActive, isMobile, config, deactivateTool } =
    useStore();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const isButtonVisible = (buttonValue: string) => {
    if (
      !config ||
      !config.toolbarOptions ||
      !config.toolbarOptions.visibleTools
    ) {
      return true;
    }
    const val = config.toolbarOptions.visibleTools[buttonValue];
    if (val === undefined) {
      return true;
    }
    return val;
  };

  const toolbarButtons: ToolbarButton[] = [
    {
      label: "Layers",
      value: DraggableKeys.LAYERS_DRAGGABLE,
      group: "left",
      hideLabelOnTablet: false,
      hideLabelOnMobile: false,
      hidden: !isButtonVisible("layers"),
    },
    {
      label: "Results",
      value: DraggableKeys.RESULTS_DRAGGABLE,
      group: "left",
      noMobile: true,
      hidden: !isButtonVisible("results"),
      // icon: resultsIcon,
    },
    {
      label: "Basemaps",
      // value: "basemaps",
      value: DraggableKeys.BASEMAP_DRAGGABLE,
      icon: basemapIcon,
      // component: BasemapsDropdown,
      group: "left",
      hidden: !isButtonVisible("basemaps"),
    },
    {
      label: "Print",
      value: DraggableKeys.PRINT_DRAGGABLE,
      icon: printIcon,
      group: "left",
      hidden: !isButtonVisible("print"),
    },

    {
      label: "Navigation",
      value: "navigation",
      group: "right",
      component: NavigationDropdown,
      icon: navigationIcon,
      noMobile: true,
      hidden: !isButtonVisible("navigation"),
    },
    {
      label: "Measure",
      value: DraggableKeys.MEASURE_DRAGGABLE,
      group: "right",
      icon: measureIcon,
      noMobile: true,
      hidden: !isButtonVisible("measure"),
    },
    {
      label: "Property Info",
      value: "propertyInfo",
      group: "right",
      icon: propertyInfoIcon,
      hidden: !isButtonVisible("select"),
    },
    {
      label: "Buffer",
      value: DraggableKeys.BUFFER_DRAGGABLE,
      group: "right",
      icon: bufferIcon,
      noMobile: true,
      hidden: !isButtonVisible("buffer"),
    },
    {
      label: "Tri-View",
      value: "triView",
      group: "right",
      icon: triViewIcon,
      hidden: !isButtonVisible("trimap"),
    },
    {
      label: "Markup",
      value: DraggableKeys.MARKUP_DRAGGABLE,
      group: "right",
      icon: markupIcon,
      noMobile: true,
      hidden: !isButtonVisible("markup"),
    },
    {
      label: "XY Coordinates",
      value: DraggableKeys.XY_COORDINATES_DRAGGABLE,
      group: "right",
      icon: xYIcon,
      noMobile: true,
      hidden: !isButtonVisible("xy"),
    },
    {
      label: "Clear Map",
      value: "clearMap",
      group: "right",
      icon: clearMapIcon,
      noToggle: true,
      hidden: !isButtonVisible("clear"),
    },
  ];

  const toolbarButtonsLeft = toolbarButtons.filter(
    (button) => button.group === "left"
  );
  const toolbarButtonsRight = toolbarButtons.filter(
    (button) => button.group === "right"
  );

  const onButtonClick = (value: string) => {
    if (value === "navigation") {
      deactivateTool("propertyInfo");
      togglePropertyInfo({ wasActive: true });
    }
    executeToolbarActions(isActive(value), value);
    toggleActiveItem(value);
  };

  return (
    <>
      {isMobile ? (
        <div
          style={{
            backgroundImage: props.options.toolbarBackgroundImage
              ? props.options.toolbarBackgroundImage
              : "linear-gradient(to bottom, #d9af66, #a58752)",
          }}
          className={`h-12  overflow-visible shadow-sm flex ${
            isMobile ? "" : "justify-between"
          }`}
        >
          {toolbarButtons.map((button, i) => (
            <React.Fragment key={i}>
              {button.noMobile ? null : (
                <ToolbarButton
                  id={i.toString()}
                  className="py-1.5"
                  active={button.noToggle ? false : isActive(button.value)}
                  label={button.icon ? undefined : button.label}
                  onClick={() => onButtonClick(button.value)}
                  icon={button.icon}
                  component={button.component}
                  highlightColor={props.options.toolbarButtonHighlightColor}
                  textColor={props.options.toolbarButtonTextColor}
                  hidden={button.hidden}
                />
              )}
            </React.Fragment>
          ))}
        </div>
      ) : (
        <div
          style={{
            backgroundImage: props.options.toolbarBackgroundImage
              ? props.options.toolbarBackgroundImage
              : "linear-gradient(to bottom, #d9af66, #a58752)",
          }}
          className="h-12 overflow-visible shadow-sm flex justify-between"
        >
          <div className="text-left flex items-center">
            {toolbarButtonsLeft.map((button, i) => (
              <ToolbarButton
                id={"left" + i}
                key={"left" + i}
                active={button.noToggle ? false : isActive(button.value)}
                label={button.label}
                onClick={() => onButtonClick(button.value)}
                icon={button.icon}
                component={button.component}
                highlightColor={props.options.toolbarButtonHighlightColor}
                textColor={props.options.toolbarButtonTextColor}
                hidden={button.hidden}
              />
            ))}
          </div>
          <div className="text-right">
            <button
              onClick={() => setIsMobileMenuOpen((prev) => !prev)}
              className={`w-12 font-trebuchet text-[12px] text-black h-full border-black border-r-0.5 px-3 hover:brightness-110 flex items-center justify-center mr-0 md:hidden`}
              style={{
                background: isMobileMenuOpen
                  ? "linear-gradient(to bottom,#e7cb95,#c6b187)"
                  : "none",
              }}
            >
              <svg
                style={{
                  stroke: props.options.toolbarButtonTextColor
                    ? props.options.toolbarButtonTextColor
                    : "black",
                }}
                className="h-6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4 18L20 18" strokeWidth="2" strokeLinecap="round" />
                <path d="M4 12L20 12" strokeWidth="2" strokeLinecap="round" />
                <path d="M4 6L20 6" strokeWidth="2" strokeLinecap="round" />
              </svg>
            </button>
            {isMobileMenuOpen && (
              <div
                style={{
                  backgroundImage: props.options.toolbarBackgroundImage
                    ? props.options.toolbarBackgroundImage
                    : "linear-gradient(to bottom, #d9af66, #a58752)",
                }}
                className="absolute top-30 z-[9999] right-0 w-48 shadow-md bg-white text-black"
              >
                <div className="flex flex-col">
                  {toolbarButtonsRight.map((button, i) => (
                    <React.Fragment key={"right-mobile" + i}>
                      {button.noMobile ? null : (
                        <ToolbarButton
                          id={"right-mobile" + i}
                          className="py-1.5"
                          active={
                            button.noToggle ? false : isActive(button.value)
                          }
                          label={button.label}
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                            onButtonClick(button.value);
                          }}
                          icon={button.icon}
                          component={button.component}
                          highlightColor={
                            props.options.toolbarButtonHighlightColor
                          }
                          textColor={props.options.toolbarButtonTextColor}
                          hideLabelOnTablet={button.hideLabelOnTablet ?? true}
                          hideLabelOnMobile={button.hideLabelOnMobile ?? true}
                          hidden={button.hidden}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}

            {toolbarButtonsRight.map((button, i) => (
              <ToolbarButton
                id={"right" + i}
                key={"right" + i}
                hiddenOnMobile={true}
                active={button.noToggle ? false : isActive(button.value)}
                label={button.label}
                onClick={() => onButtonClick(button.value)}
                icon={button.icon}
                component={button.component}
                hideLabelOnTablet={button.hideLabelOnTablet ?? true}
                hideLabelOnMobile={button.hideLabelOnMobile ?? true}
                highlightColor={props.options.toolbarButtonHighlightColor}
                textColor={props.options.toolbarButtonTextColor}
                hidden={button.hidden}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};
